<fa-icon [icon]="faCalendar"></fa-icon> {{message.createDate | date: 'dd-MM-yyyy'}} - &nbsp; <fa-icon [icon]="faUser"></fa-icon>

<ng-container>
  {{publishedBy}}
</ng-container>
